import { jsx as _jsx } from "react/jsx-runtime";
import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';

const AddonPanel = ({
  purchaseMotions,
  upgradeData
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: purchaseMotions.map((purchaseMotion, i) => /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
      use: "primary",
      purchaseMotions: purchaseMotions,
      level: i + 1,
      upgradeData: upgradeData,
      location: MERCH_CARD
    }, purchaseMotion))
  });
};

export default AddonPanel;